import getTargettedTabIndex from './getTargettedTabIndex';
import selectTab from './selectTab';

/**
 * Selects and focuses the tab after targettedTab within listOfTabs.
 * @param   {Object}   targettedTab    the currently focussed tab.
 * @param   {NodeList} listOfTabs      the NodeList containing targettedTab.
 * @param   {NodeList} listOfTabPanels the NodeList of tab panels corresponding
 * to the tabs in listOfTabs.
 */
const selectNextTab = (targettedTab, listOfTabs, listOfTabPanels) => {
  const targettedTabIndex = getTargettedTabIndex(targettedTab, listOfTabs);
  if (targettedTabIndex === listOfTabs.length - 1) {
    selectTab(listOfTabs[0], listOfTabs, listOfTabPanels);
  } else if (targettedTabIndex !== -1) {
    selectTab(listOfTabs[targettedTabIndex + 1], listOfTabs, listOfTabPanels);
  }
};

export default selectNextTab;
